import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">
  <Link to="/" className="logo-link">
    <img 
      src="/logo.jpg" 
      alt="MarkMe Logo"
      className="logo-img"
    />
    <span className="logo-text">MarkMe</span>
  </Link>
</div>



      {/* Menu */}
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/admin-login">Admin Dashboard</Link></li>
        <li><Link to="/faculty-dashboard">Faculty Dashboard</Link></li>
        <li><Link to="/student-dashboard">Student Dashboard</Link></li>
      </ul>
    </nav>
  );
}

export default Navbar;
